import React, { useEffect, useRef, useState } from 'react';
import propTypes from 'prop-types';
import { Box, Card, CardMedia, Grid, Skeleton, Stack, Typography } from '@mui/material';
import Slider from 'react-slick'; // Import the Slider component from react-slick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// Import icons from Material-UI Icons

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useCloudinary from '../../../hooks/useCloudinaryImage';
import { useDevice } from '../../../hooks/useResponsive';
import { getAllVehiclesByFeatured } from '../../../server/api/category';

FeaturedCars.propTypes = {
  addMargin: propTypes.any,
};
export default function FeaturedCars() {
  const { isMobile } = useDevice();
  const sliderRef = useRef();

  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);

  const [currentSlide, setCurrentSlide] = useState(0);

  const { allVehicleList, loading } = useSelector((state) => ({
    allVehicleList: state?.category?.allVehicleListByFeatured?.vehicles,
    loading: state?.category?.loading,
  }));

  // console.log(allVehicleList);

  useEffect(() => {
    dispatch(getAllVehiclesByFeatured());
  }, [dispatch]);

  // Custom left arrow component
  // const CustomPrevArrow = (props) => {
  //   // eslint-disable-next-line react/prop-types
  //   const { onClick } = props;
  //   return (
  //     <div
  //       className="arrow arrow-left leftrArrow-feature"
  //       role="button"
  //       tabIndex="0"
  //       onClick={onClick}
  //       onKeyDown={(e) => {
  //         if (e.key === 'Enter') onClick();
  //       }}
  //     >
  //       <ChevronLeftIcon sx={{ fontSize: 30 }} /> {/* Use the ChevronLeftIcon from Material-UI Icons */}
  //     </div>
  //   );
  // };

  // Custom right arrow component
  // const CustomNextArrow = (props) => {
  //   // eslint-disable-next-line react/prop-types
  //   const { onClick } = props;
  //   return (
  //     <div
  //       className="arrow arrow-right RighrArrow-feature"
  //       role="button"
  //       tabIndex="0"
  //       onClick={onClick}
  //       onKeyDown={(e) => {
  //         if (e.key === 'Enter') onClick();
  //       }}
  //     >
  //       <ChevronRightIcon sx={{ fontSize: 30 }} /> {/* Use the ChevronRightIcon from Material-UI Icons */}
  //     </div>
  //   );
  // };

  // Configuration for the carousel
  const carouselSettings = {
    dots: isMobile,
    infinite: !isMobile,
    speed: 500,
    autoplay: !isMobile,
    autoplaySpeed: 2500,
    slidesToShow: isMobile ? 1.3 : 3,
    // slidesToScroll: 1,
    arrows: null,
    prevArrow: null,
    nextArrow: null,
    centerMode: false,

    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),

    appendDots: (dots) => (
      <div className="custom-slick-dots-wrapper" style={{ textAlign: 'center', marginTop: '10px' }}>
        <ul style={{ margin: 0, padding: 0, display: 'inline-flex' }}>{dots}</ul>
      </div>
    ),

    customPaging: (i) => {
      // const isActive = i === currentSlide;
      const slidesToScroll = carouselSettings.slidesToScroll || 1;
      const isActive = i === Math.round(currentSlide / slidesToScroll);

      return (
        <div
          style={{
            width: isActive ? '25px' : '12px',
            height: '5px',
            borderRadius: '8px',
            backgroundColor: isActive ? '#6A5843' : '#ccc', // brownish active, light gray inactive
            margin: '0 2px',
            transition: 'all 0.3s ease',
          }}
        />
      );
    },
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(1, false);
        setTimeout(() => {
          sliderRef.current.slickGoTo(0, false);
        }, 100);
      }
      setMounted(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (!mounted) return null;
  return (
    <>
      {allVehicleList?.length > 0 && (
        <Stack
          sx={{ px: !isMobile && '75px', pb: 4, pl: isMobile ? '7px' : '75px' }}
          className="custom-slick-dots-wrapper"
        >
          {/* <Typography className="featured-text" pb={2}>
              Featured Cars
            </Typography> */}
          <Slider {...carouselSettings} className="custom-feature-slider">
            {loading
              ? [...Array(4)].map((_, index) => (
                  <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      height={isMobile ? 180 : 200}
                      width="100%"
                      sx={{ backgroundColor: '121212' }}
                    />
                  </Stack>
                ))
              : allVehicleList?.map((car, key) => (
                  <div key={key} className="feature-slider">
                    <Card className="CardTransform-feature-cars" sx={{ borderRadius: isMobile ? '12px' : '5px' }}>
                      {car && car?.images[0] ? (
                        <CardMedia
                          component="img"
                          className="card-img-feature samesize"
                          // src={car?.images[0]?.url}
                          src={
                            car?.images[0]?.url
                              ? // eslint-disable-next-line react-hooks/rules-of-hooks
                                useCloudinary(car?.images[0]?.url, 'w_400,q_auto,f_auto')
                              : '/assets/car.png'
                          }
                          alt="Card Image"
                        />
                      ) : (
                        <CardMedia
                          component="img"
                          className="card-img-feature samesize"
                          src={'/assets/images/Feature/black.png'}
                          alt="Card Image"
                        />
                      )}
                      <Box className="featured-img">
                        <Link to={`/product-single/${car?._id}`} style={{ textDecoration: 'none' }}>
                          <Box pr={2}>
                            {car?.makeYear !== 0 && (
                              <Typography variant="caption" fontWeight={600} className="featured-img-text">
                                {' '}
                                {car?.makeYear && <CalendarMonthIcon style={{ fontSize: '13px' }} />}
                                {car?.makeYear}
                              </Typography>
                            )}
                            <Typography variant="body1" fontSize={25} className="featured-img-text">
                              {' '}
                              {car?.name}
                            </Typography>
                            <Typography variant="body1" className="featured-img-text">
                              {' '}
                              {car?.variant?.name}
                            </Typography>
                            {car?.fuelType && (
                              <Typography variant="body2" fontWeight={600} className="featured-img-text">
                                {' '}
                                Fuel
                              </Typography>
                            )}
                            <Typography variant="body1" className="featured-img-text">
                              {' '}
                              {car?.fuelType}
                            </Typography>
                            <Grid display={'flex'} justifyContent={'end'} mt={1}>
                              {car && car?.brand && car?.brand?.logo && (
                                <CardMedia
                                  component="img"
                                  className=""
                                  src={car?.brand?.logo[0]?.url}
                                  alt="Card Image"
                                  style={{ width: '35px' }}
                                />
                              )}
                            </Grid>
                          </Box>
                        </Link>
                      </Box>
                    </Card>
                  </div>
                ))}
          </Slider>
        </Stack>
      )}
    </>
  );
}
